import { Mail, Instagram } from "lucide-react";
import { WA_NUMBER_DISPLAY, waLink, DEFAULT_WA_MSG, CATEGORIES } from "../data/catalogue";
import { WhatsAppIcon, scrollToSection } from "./Shared";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-espresso text-cream border-t border-cream/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-5">
              <img
                src="/anubandh-logo.jpg"
                alt="Anubandh logo"
                className="h-20 w-20 rounded-full border-2 border-peach/60 object-cover"
              />
              <div>
                <p className="font-display text-4xl text-peach leading-none">अनुबंध</p>
                <p className="mt-2 font-serif italic text-lg text-cream/70">
                  Elevating Every Expression
                </p>
              </div>
            </div>
            <p className="mt-8 max-w-md text-sm leading-relaxed text-cream/60">
              A customised gifting studio for bags, desktop gifts, divine idols and curated
              gift sets. Screenshot what you love, and we&apos;ll help with the rest.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href={waLink(DEFAULT_WA_MSG)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-cta"
                className="inline-flex items-center gap-2.5 rounded-full border border-cream/25 px-6 py-3 text-sm font-semibold hover:bg-sage hover:text-espresso hover:border-sage transition-colors duration-300"
              >
                <WhatsAppIcon className="h-4 w-4" />
                WhatsApp · {WA_NUMBER_DISPLAY}
              </a>
              <a
                href="mailto:anubandhgifting@gmail.com"
                data-testid="footer-email-cta"
                className="inline-flex items-center gap-2.5 rounded-full border border-cream/25 px-6 py-3 text-sm font-semibold hover:bg-peach hover:text-espresso hover:border-peach transition-colors duration-300"
              >
                <Mail className="h-4 w-4" />
                anubandhgifting@gmail.com
              </a>
              <a
                href="https://www.instagram.com/anubandh_gifting"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-cta"
                className="inline-flex items-center gap-2.5 rounded-full border border-cream/25 px-6 py-3 text-sm font-semibold hover:bg-peach hover:text-espresso hover:border-peach transition-colors duration-300"
              >
                <Instagram className="h-4 w-4" />
                @anubandh_gifting
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cream/50">
              Catalogues
            </p>
            <ul className="mt-6 space-y-3.5">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <a
                    href={c.pdf}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-download-${c.id}-pdf`}
                    className="text-sm text-cream/75 hover:text-peach transition-colors duration-300"
                  >
                    {c.title} PDF
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cream/50">
              Explore
            </p>
            <ul className="mt-6 space-y-3.5">
              {[
                { label: "Collections", hash: "#collections" },
                { label: "Spotlight", hash: "#spotlight" },
                { label: "How it works", hash: "#how" },
                { label: "Quantities & MOQ", hash: "#moq" },
              ].map((l) => (
                <li key={l.hash}>
                  <a
                    href={l.hash}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(l.hash);
                    }}
                    data-testid={`footer-link-${l.hash.slice(1)}`}
                    className="text-sm text-cream/75 hover:text-peach transition-colors duration-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-cream/10 pt-8">
          <p className="text-xs text-cream/45">
            © {new Date().getFullYear()} Anubandh · Elevating Every Expression
          </p>
          <p className="text-xs text-cream/45">
            Customised: min 35 pcs · Normal: any quantity
          </p>
        </div>
      </div>
    </footer>
  );
}
